import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {EntityClass} from '../entity.class';
import {entityDecorator} from '../entity.decorator';
// import construct = Reflect.construct;

@Injectable()
@entityDecorator({
  url: 'api/mentalseal/v1/app',
  idName: 'appId',
  protobufJSON: require('assets/protobuf/mentalseal/mentalseal.json'),
  protobufModule: 'App'
})
export class MentalsealAppService extends EntityClass {

  private updateRole (data: {}, id: number) {
    this.itemValues[id] = this.itemValues[id] || {};
    this.itemValues[id].role.length > 0 ? this.itemValues[id].role.push(data) : this.itemValues[id].role = [data];
  }

  addRole (id: number, params: {}): Observable<any> {
    return this.http.post(environment.baseUrl + this['url'] + '/' + id + '/role', params)
      .map((response: any) => {
        const resp: any = response.json();
        const result: any = resp.result;
        const data: any = resp.data || {};
        return {data: data, result: result};
      }).map((response) => {
        if (response.result.success === true) {
        } else {
          if (response.result.code === 401) {
            this.router.navigateByUrl('/login');
          } else if (parseInt(response.result.code, 0) > 10000 || response.result.code === 500) {
            swal('服务器错误', response.result.displaymsg, 'error');
          } else {}
          throw {result: response.result};
        }
        response.data = response.data || {};
        this.updateRole(response.data, id);
        return response;
      });
  }
}




// WEBPACK FOOTER //
// D:/taile-operate/BLACK-WIDOW/ng-src/app/services/entity-base/entity-service/mentalseal-app.service.ts